import React from 'react'
import "../../Assets/Css/Leave.scss"
import { useNavigate } from 'react-router-dom'

const ApproveRejectLeave = () => {
     const navigate = useNavigate()

     const handleBack = () => {
          navigate('/leave')
     }
     return (
               <div className='approve-reject-container'>

                    <div className='header-part'>
                         <p className='title-part'>Leaves Approve/Reject Reason</p>
                         <div className="action-button">
                              <button
                                   type="submit"
                                   className="custom-btn"
                                   onClick={handleBack}
                              >
                                   Cancel
                              </button>

                              <button
                                   type="submit"
                                   className="custom-btn"
                                   onClick={handleBack}
                              >
                                   Save
                              </button>
                         </div>
                    </div>
                    <div className='card-part'>
                         <div className="input-group">
                              <div className="reason-title">Reason</div>
                              <textarea rows="4" cols="50" className="input-css" style={{ width: "100%" }} name="reason" placeholder="Write something awesome..." />
                         </div>
                    </div>
               </div>
     )
}

export default ApproveRejectLeave
